const DTODBA09 = {
  joinTeam: "/api/DTODBA09/joinTeam",
  queryTeamByPNO: "/api/DTODBA09/queryTeamByPNO",
  checkTeamMemberEnough: "/api/DTODBA09/checkTeamMemberEnough",
  queryTeamMember: "/api/DTODBA09/queryTeamMember",
  handOverLeader: "/api/DTODBA09/handOverLeader",
  deleteTeamMember: "/api/DTODBA09/deleteTeamMember",
  modifyTeamMemberBackend: "/api/DTODBA09/modifyTeamMemberBackend"
};

export default DTODBA09;
